import { createFileRoute } from "@tanstack/react-router";
import FederalEmployeeSaintTms from "@/pages/FederalEmployeeSaintTms";
export const Route = createFileRoute("/federal-employee-saint-tms")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Federal Employee SAINT® TMS | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Federal employees: SAINT TMS for treatment-resistant depression, FEHB coverage, and travel-in support from Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Federal Employee SAINT® TMS | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Federal employees: SAINT TMS for treatment-resistant depression, FEHB coverage, and travel-in support from Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/federal-employee-saint-tms",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/federal-employee-saint-tms",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <FederalEmployeeSaintTms />;
}
